import modelService from '@/services/model'

export default {
  // I've deliberately made all these hang off of Ticket for sanity sake. The API supports direct access
  ticketIndex: (cbOk, cbErr, ticketId, pagination = null) => {
    let url = `/tickets/${ticketId}/comments.json`
    if (pagination) {
      url += '?' + modelService.paginationParams(pagination)
    }
    return modelService.index(cbOk, cbErr, url)
  },

  ticketShow: (cbOk, cbErr, ticketId, id) => {
    return modelService.show(cbOk, cbErr, `/tickets/${ticketId}/comments/${id}.json`)
  },

  show: (cbOk, cbErr, id) => {
    return modelService.show(cbOk, cbErr, `/comments/${id}.json`)
  },

  ticketCreate: (cbOk, cbErr, ticketId, instance) => {
    return modelService.create(cbOk, cbErr, instance, `/tickets/${ticketId}/comments.json`)
  },

  ticketUpdate: (cbOk, cbErr, ticketId, instance) => {
    return modelService.update(cbOk, cbErr, instance, `/tickets/${ticketId}/comments/${instance.id}.json`)
  },

  ticketDelete: (cbOk, cbErr, ticketId, id) => {
    return modelService.delete(cbOk, cbErr, `/tickets/${ticketId}/comments/${id}.json`)
  },

  deleteAttachment: (cbOk, cbErr, commentId, id) => {
    return modelService.delete(cbOk, cbErr, `/comments/${commentId}/attachments/${id}.json`)
  },

  share: (cbOk, cbErr, instance) => {
    return modelService.update(cbOk, cbErr, instance, `/comments/${instance.id}/share.json`)
  }

}



// WEBPACK FOOTER //
// ./src/services/comment.js